import { library } from "@fortawesome/fontawesome-svg-core";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
    faFile,
    faCheck,
    faTruck,
    faMap,
    faRoad,
    faCalendar,
    faQuestion,
    faBuilding,
    faCircle,
    faUser,
    faUserCircle,
    faIdCard,
    faCamera,
    faMapMarkerAlt,
    faCheckCircle,
    faMoneyBillAlt,
    faPen,
    faBars,
    faPlus,
    faFileImport,
    faClipboardList,
    faShieldAlt,
    faHandHoldingUsd,
    faCalculator,
    faFileAlt,
    faBoxOpen,
    faBoxes,
    faSignInAlt,
    faSearch,
    faCalendarAlt,
    faBook,
    faEdit
} from "@fortawesome/free-solid-svg-icons";
import {
    faFile as faFileRegular,
    faCalendar as faCalendarRegular,
    faBuilding as faBuildingRegular,
    faCircle as faCircleRegular,
    faUser as faUserRegular,
    faIdCard as faIdCardRegular,
    faCheckCircle as faCheckCircleRegular,
    faMoneyBillAlt as faMoneyBillAltRegular
} from "@fortawesome/free-regular-svg-icons";

library.add(
    faFile,
    faCheck,
    faTruck,
    faMap,
    faRoad,
    faCalendar,
    faQuestion,
    faUser,
    faUserCircle,
    faGoogle,
    faBuilding,
    faCircle,
    faIdCard,
    faCamera,
    faMapMarkerAlt,
    faCheckCircle,
    faMoneyBillAlt,
    faPen,
    faBars,
    faPlus,
    faFileImport,
    faClipboardList,
    faShieldAlt,
    faHandHoldingUsd,
    faCalculator,
    faFileAlt,
    faBoxOpen,
    faBoxes,
    faSignInAlt,
    faSearch,
    faCalendarAlt,
    faBook,
    faEdit,
    faFileRegular,
    faCalendarRegular,
    faBuildingRegular,
    faCircleRegular,
    faUserRegular,
    faIdCardRegular,
    faCheckCircleRegular,
    faMoneyBillAltRegular
);
